import { Box } from "@mui/material";
import { ItemCard } from "./itemCard.component";
import { useEffect } from "react";
import { api } from "../../../config/apiCaller.config";

export interface CatalogItem {
    _id: string;
    name: string;
    description: string;
    points: number;
    medias: string[];
}

export interface CatalogProps {
    items: CatalogItem[];
    setSelectedReward: (reward: CatalogItem) => void;
}


const Catalog: React.FC<CatalogProps> = ({items, setSelectedReward}: CatalogProps) => {
    return (
        <Box 
            display="flex"
            flexWrap={'wrap'}
            justifyContent={'center'}
            bgcolor="#FFFFFF">
                {items?.map((item) => <ItemCard key={item._id} item={item} setSelectedReward={setSelectedReward} />)}
        </Box>
    );
}

export { Catalog };